<template>
  <div class="van-image" style="width: 100%; height: 100%;">
    <iframe :src="pdfSrc" frameborder="0"></iframe>
  </div>
</template>

<script>
import {Base64} from "js-base64";
export default {
  components: {
    Base64,
  },
  data() {
    return {
      pdfSrc: Base64.decode(this.$route.query.pdf) //"https://smart-curtain.oss-cn-hangzhou.aliyuncs.com/quotation-report/70020-9baaf739cac64fb3b56994807a0573f5.pdf",//"./roomicon/111.pdf",//
    }
  },
  mounted() {
  },
  methods: {

  }

}
</script>